import SensorModal from './SensorModal';

export default SensorModal;